'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$() {
  this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_defaultMake$lzy20 = null;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_defaultMakebitmap$20 = false;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_make$lzy20 = null;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_makebitmap$20 = false;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_given_Show_Type$lzy17 = null;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_given_Show_Typebitmap$17 = false;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_validator = null;
  $n_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validator$();
  var x = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lyantl_ValidatorRule.getArrayOf().constr)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lyantl_ValidatorRule$().maxLength__I__Lyantl_ValidatorRule(2000)]);
  this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validator$().fromRules__ALyantl_ValidatorRule__Lyantl_Validator(x);
}
export { $c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$ as $c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$ };
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$.prototype.constructor = $c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$;
/** @constructor */
function $h_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$() {
}
export { $h_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$ as $h_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$ };
$h_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$.prototype = $c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$.prototype;
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_defaultMakebitmap$20)) {
    this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_defaultMake$lzy20 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_defaultMakebitmap$20 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_defaultMake$lzy20;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_makebitmap$20)) {
    this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_make$lzy20 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_makebitmap$20 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_make$lzy20;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$.prototype.given_Show_Type__Lcats_Show = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_given_Show_Typebitmap$17)) {
    this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_given_Show_Type$lzy17 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_given_Show_Typebitmap$17 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_given_Show_Type$lzy17;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$.prototype.validate__Lyantl_Validate = (function() {
  return this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$__f_validator;
});
var $d_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$, "app.data.types_drug$package$DrugRequestAcceptedNote$", ({
  Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lframework_utils_NewtypeString: 1,
  Lyantl_Newtype$ValidatedOf: 1
}));
export { $d_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$ as $d_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$ };
var $n_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$;
function $m_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$() {
  if ((!$n_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$)) {
    $n_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$ = new $c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$();
  }
  return $n_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$;
}
export { $m_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$ as $m_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$ };
//# sourceMappingURL=app.data.types_drug$package$-Drug-Request-Accepted-Note$.js.map
